export default {
    title: 'ยื่นคำขอทำงานล่วงเวลา',
    cannotGetLineId: 'เกิดข้อผิดพลาด',
    startDate: 'วันที่เริ่มต้น',
    endDate: 'วันที่สิ้นสุด',
    startTime: 'เวลาเริ่มต้น',
    otTime: 'ชั่วโมง OT/วัน',
    reason: 'เหตุผล',
    reasonPlaceholder: 'คำอธิบายเกี่ยวกับงานล่วงเวลาที่จะทำ',
    formTitle: 'คำร้อง',
    totalReqHrsLabel: 'ชั่วโมงที่ขอทั้งหมด',
    hr: 'ชั่วโมง',
    hrs: 'ชั่วโมง',
    overlapLocal: 'ช่วงเวลาที่ระบุคาบเกี่ยวกับช่วงเวลาในคำขออื่น',
    startDateOverlap: 'วันที่เริ่มต้นต้องอยู่ก่อนวันที่สิ้นสุด',
    endDateOverlap: 'วันที่สิ้นสุดต้องอยู่หลังจากวันที่เริ่มต้น',
    requestSuccess: 'ส่งคำขอล่วงเวลาสำเร็จ',
    employeeName: 'ชื่อ',
    employeeNo: 'รหัสพนักงาน',
    date: 'วันที่',
    approvalInquiry: 'อนุมัติคำร้องขอ',
    back: 'ย้อนกลับ',
    totalInquiry: 'คำร้องทั้งหมด'
}
